import React, { useState, useEffect } from 'react';

function ModalEditPatient({ API_URL, token, patient, onFermer, onSauvegarder }) {
    const [prenom, setPrenom]   = useState('');
    const [nom, setNom]         = useState('');
    const [age, setAge]         = useState('');
    const [tel, setTel]         = useState('');
    const [sexe, setSexe]       = useState(null);
    const [erreur, setErreur]   = useState('');

    useEffect(() => {
        if (patient) {
            setPrenom(patient.prenom || '');
            setNom(patient.nom       || '');
            setAge(patient.age       || '');
            setTel(patient.telephone || '');
            setSexe(patient.sexe     || null);
        }
    }, [patient]);

    async function sauvegarder() {
        if (!prenom || !nom) {
            setErreur('Veuillez renseigner le prénom et le nom.');
            return;
        }
        setErreur('');
        try {
            const res = await fetch(`${API_URL}/patients/${patient.id}`, {
                method : 'PUT',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "true" },
                body   : JSON.stringify({
                    nom, prenom,
                    age      : age ? parseInt(age) : null,
                    sexe     : sexe,
                    telephone: tel || null
                })
            });
            if (!res.ok) throw new Error('Erreur serveur');
            const data = await res.json();
            onSauvegarder(data);
        } catch(e) {
            setErreur('Erreur lors de la sauvegarde.');
        }
    }

    const inputStyle = {
        width: '100%', padding: '10px 14px',
        background: 'var(--bg)', border: '1px solid var(--border)',
        borderRadius: '8px', color: 'var(--text)',
        fontSize: '14px', outline: 'none'
    };

    const labelStyle = {
        display: 'block', fontSize: '12px',
        color: 'var(--text-muted)', marginBottom: '6px', marginTop: '16px'
    };

    if (!patient) return null;

    return (
        <div
            onClick = {e => e.target === e.currentTarget && onFermer()}
            style={{
                display: 'flex', position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 100,
                alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div style={{
                background: 'var(--bg-light)', border: '1px solid var(--border)',
                padding: '32px', borderRadius: '12px',
                width: '440px', maxWidth: '90vw'
            }}>
                <h3 style={{ fontSize: '16px', fontWeight: 500, color: 'var(--white)', marginBottom: '24px' }}>
                    ✏️ Modifier le patient
                </h3>

                {/* Prénom + Nom */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div>
                        <label style={labelStyle}>Prénom *</label>
                        <input
                            type        = "text"
                            value       = {prenom}
                            onChange    = {e => setPrenom(e.target.value)}
                            placeholder = "Mohamed"
                            style       = {inputStyle}
                        />
                    </div>
                    <div>
                        <label style={labelStyle}>Nom *</label>
                        <input
                            type        = "text"
                            value       = {nom}
                            onChange    = {e => setNom(e.target.value)}
                            placeholder = "Ben Ali"
                            style       = {inputStyle}
                        />
                    </div>
                </div>

                {/* Âge + Téléphone */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px', marginTop: '16px' }}>
                    <div>
                        <label style={labelStyle}>Âge</label>
                        <input
                            type        = "number"
                            value       = {age}
                            onChange    = {e => setAge(e.target.value)}
                            placeholder = "45"
                            min="0" max="150"
                            style       = {inputStyle}
                        />
                    </div>
                    <div>
                        <label style={labelStyle}>Téléphone</label>
                        <input
                            type        = "tel"
                            value       = {tel}
                            onChange    = {e => setTel(e.target.value)}
                            placeholder = "+216 55 123 456"
                            style       = {inputStyle}
                        />
                    </div>
                </div>

                {/* Sexe */}
                <label style={labelStyle}>Sexe</label>
                <div style={{ display: 'flex', gap: '12px', marginTop: '6px' }}>
                    {['M', 'F'].map(s => (
                        <div
                            key     = {s}
                            onClick = {() => setSexe(s)}
                            style={{
                                flex: 1, display: 'flex', alignItems: 'center',
                                justifyContent: 'center', gap: '8px',
                                padding: '9px 14px', background: 'var(--bg)',
                                border: `1px solid ${sexe === s ? 'var(--white)' : 'var(--border)'}`,
                                borderRadius: '8px', cursor: 'pointer',
                                fontSize: '13px',
                                color: sexe === s ? 'var(--white)' : 'var(--text-muted)'
                            }}
                        >
                            {s === 'M' ? '♂ Homme' : '♀ Femme'}
                        </div>
                    ))}
                </div>

                {/* Erreur */}
                {erreur && (
                    <div style={{ color: '#e06c6c', fontSize: '12px', marginTop: '8px' }}>
                        {erreur}
                    </div>
                )}

                {/* Boutons */}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '24px' }}>
                    <button
                        onClick = {onFermer}
                        style={{
                            padding: '9px 18px', background: 'transparent',
                            border: '1px solid var(--border)', borderRadius: '8px',
                            color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer'
                        }}
                    >Annuler</button>
                    <button
                        onClick = {sauvegarder}
                        style={{
                            padding: '9px 18px', background: 'var(--white)',
                            color: '#1a1a1a', border: 'none',
                            borderRadius: '8px', fontSize: '13px',
                            fontWeight: 500, cursor: 'pointer'
                        }}
                    >Sauvegarder</button>
                </div>
            </div>
        </div>
    );
}

export default ModalEditPatient;